module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "_about",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('div', {
    staticClass: "auth"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "i200",
    attrs: {
      "alt": "author photo",
      "src": "image/Blake_Deborah_ColorConjure.png"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Bobbie Hodges")])])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_vm._v("Deborah Blake is the award-winning author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Goddess is in the Details")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Everyday Witchcraft,")]), _vm._v(" and numerous other books from Llewellyn, along with the popular "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Everyday Witch Tarot")]), _vm._v(" kit. She has published articles in Llewellyn annuals, and her ongoing column, “Everyday Witchcraft,” is featured in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Witches & Pagans")]), _vm._v(" magazine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deborah’s also the author of the paranormal romance Baba Yaga series from Berkley Publishing, as well as the Veiled Magic urban fantasies. She can be found online at Facebook, Twitter, and www.deborahblakeauthor.com. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When not writing, Deborah runs the Artisans’ Guild, a cooperative shop she founded with a friend in 1999, and also works as a jewelry maker, tarot reader, and energy healer. She lives in a 130-year-old farmhouse in rural upstate New York with various cats who supervise all her activities, magickal and mundane.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1801f507","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 57
// module chunks = 0